module.exports = __webpack_public_path__ + "img/step3.906dbf4e.svg";